import React from "react";
import { Part1Text2 } from "./styles";

interface TextProps {
  text: string;
  maxLength: number;
}

const Controlledtext: React.FC<TextProps> = ({ text, maxLength }) => {
  const truncatedText =
    text.length > maxLength ? text.slice(0, maxLength) : text;

  return <Part1Text2>{truncatedText}...</Part1Text2>;
};

export default Controlledtext;
